import React from "react";
import UlLi, {scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import Highlight from "react-highlight";
import { Navigation, Link } from "react-router";
import UserHandler from "js/utilities/user-handler";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import ApptokenDisplay from "js/utilities/get-display-apptoken";
import { ZOOM_ICON } from "js/config.jsx";
import SDKSidebar from "js/utilities/sdk-sidebar";

import ENCRYPTION_KEYS_SWIFT from "resources/code/ios/encryption-keys.swift.tpl";
import ENCRYPTION_KEYS_OBJC from "resources/code/ios/encryption-keys.m.tpl";
import ENCRYPTION_KEY_JAVA from "resources/code/hybrid/android/07-set-encryption-key.java.tpl";
import ENCRYPTION_KEY_JAVA_SERVER from "resources/code/ios/encryption-keys.java.tpl";
import ENCRYPTION_KEY_JS from "resources/code/ios/encryption-keys.js.tpl";
import SDK_INITIALIZE_SWIFT from "resources/code/quickstart/ios/00-initialize.swift.tpl";
import SDK_INITIALIZE_OBJC from "resources/code/quickstart/ios/00-initialize.m.tpl";
import SDK_IMPORT_SWIFT from "resources/code/quickstart/ios/01-import.swift.tpl";
import SDK_IMPORT_OBJC from "resources/code/quickstart/ios/01-import.m.tpl";
import SDK_START_ENROLLMENT_SWIFT from "resources/code/quickstart/ios/02-start-enrollment.swift.tpl";
import SDK_START_ENROLLMENT_OBJC from "resources/code/quickstart/ios/02-start-enrollment.m.tpl";
import ON_BEFORE_DISMISS_SWIFT from "resources/code/ios/37-exit-animations.swift.tpl";
import ON_BEFORE_DISMISS_OBJC from "resources/code/ios/37-exit-animations.m.tpl";


export default React.createClass({
  displayName: "ios-guide",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var data  = [
        ];

    var scrollToElement = initDeepLinkData(this.props);

    return {
      data: data,
      navMenuParent: null,
      navMenu: null,
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container">
              <section>
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="facemap-encryption-keys">FaceMap Encryption Keys</h2>
                </div>
                <p>FaceMap Encryption Keys are required by default and provide baseline security for your data.</p>
                <hr/>
              </section>

              <section>
                <h3 id="overview">Overview</h3>
                <p>FaceMaps are encrypted by default using a combination of asymmetric RSA encryption and randomized AES-256 encryption. Generating your own key pair ensures that FaceMaps cannot be tampered with after they are created.  Your public FaceMap Encryption Key is used internally by the FaceTec Device SDKs to encrypt your app's FaceMaps.  Your private FaceMap Encryption Key is used internally by the FaceTec Server SDK to decrypt and allow processing of your app's FaceMaps.</p>
              </section>

              <hr/>

              <section>
                <h3 id="requirements">Requirements</h3>
                <p>To run FaceTec in production, <strong>you are required</strong> to generate a public/private key pair and initialize your Device and Server SDKs with them.</p>

                <blockquote>
                  <p><strong>Important</strong>: You must use the public key in the FaceTec Device SDKs that corresponds to the private key that FaceTec Server is using.  FaceMaps cannot be processed if they cannot be decrypted.  A public/private key mismatch is one likely cause of "FaceMap could not be decrypted" issues.</p>
                </blockquote>
              </section>

              <hr/>

              <section>
                <h3 id="generating-keys">Generating Keys</h3>
                <p>To create your FaceMap Encryption keys and configure them in the FaceTec SDKs, please follow the steps below:</p>
                <ul>
                  <li><p>To create your private key, run: <code>openssl genpkey -algorithm RSA -pkeyopt rsa_keygen_bits:2048 | openssl pkcs8 -topk8 -nocrypt > PrivateFaceMapEncryptionKey.pem</code></p></li>
                  <li><p>To create your public key, run: <code>openssl rsa -pubout -in PrivateFaceMapEncryptionKey.pem -out PublicFaceMapEncryptionKey.pub</code></p></li>
                </ul>

                <blockquote>
                  <p><strong>Windows Users</strong>: Please see <a target="_blank" href="https://tutorials.ubuntu.com/tutorial/tutorial-ssh-keygen-on-windows#3">this guide</a> for quick steps to creating your public/private key pair.</p>
                </blockquote>
              </section>

              <hr/>

              <section>
                <h3 id="using-your-keys">Using Your Keys</h3>
                <p>Set the public encryption key in the FaceTec Device SDKs per the code snippets below by using the <code>ZoomSDK.setFacemapEncryptionKey</code> function.</p>
                <div className="code-container">
                  <CodeBlocks swift={ENCRYPTION_KEYS_SWIFT()} objC={ENCRYPTION_KEYS_OBJC()} java={ENCRYPTION_KEY_JAVA()} js={ENCRYPTION_KEY_JS()} />
                </div>

                <p>Set the private encryption key in the FaceTec Server SDK per the code snippet below by passing the key into the appropriate initialization function.</p>
                <div className="code-container">
                  <CodeBlocks server-java={ENCRYPTION_KEY_JAVA_SERVER()} />
                </div>
                <p></p>
             </section>
          </div>
          <SDKSidebar menuType="main" title="Encryption Keys"/>

        </div>
      </div>
    </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/facemap-encryption-keys.jsx